<ng-container *transloco="let t; read: 'home'">
  <div class="p-grid p-nogutter whenToBuy p-jc-center">
    <div class="wrapper p-grid p-nogutter p-jc-center section-margin">
      <div class="p-col-12 p-text-center whenToBuy__header">
        <h2 class="home-heading">
          {{ t('whenToBuy.header.part1') }}
        </h2>
      </div>

      <div class="p-col-12 whenToBuy__blocks">
        <div class="p-grid p-nogutter p-jc-center">
          <div class="p-col-12 p-md-4 whenToBuy__block">
            <div class="whenToBuy__block__content">
              <div class="whenToBuy__block__icon">
                <img
                  src="assets/images/ikona_180_dni.png"
                  alt="calendar"
                  class="whenToBuy__block__icon__img"
                  loading="lazy"
                  decoding="async" width="300" height="300">
              </div>
              <h3 class="textBlue p-text-bold p-mb-2">
                {{ t('whenToBuy.content.block1.header') }}
              </h3>
              <p
                class="textBlue"
                [innerHTML]="t('whenToBuy.content.block1.text')"></p>
            </div>
          </div>

          <div class="p-col-12 p-md-4 whenToBuy__block">
            <div class="whenToBuy__block__content">
              <div class="whenToBuy__block__icon">
                <img
                  src="assets/images/ikona_30_dni.png"
                  alt="calendar"
                  class="whenToBuy__block__icon__img"
                  loading="lazy"
                  decoding="async" width="300" height="300">
              </div>
              <h3 class="textBlue p-text-bold p-mb-2">
                {{ t('whenToBuy.content.block2.header') }}
              </h3>
              <p
                class="textBlue"
                [innerHTML]="t('whenToBuy.content.block2.text')"></p>
            </div>
          </div>

          <div class="p-col-12 p-md-4 whenToBuy__block">
            <div class="whenToBuy__block__content">
              <div class="whenToBuy__block__icon">
                <img
                  src="assets/images/ikona_flex.png"
                  alt="calendar"
                  class="whenToBuy__block__icon__img"
                  loading="lazy"
                  decoding="async" width="300" height="300">
              </div>
              <h3 class="textBlue p-text-bold p-mb-2">
                {{ t('whenToBuy.content.block3.header') }}
              </h3>
              <p
                class="textBlue"
                [innerHTML]="t('whenToBuy.content.block3.text')"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-text-center whenToBuy__additional">
        <p class="textBlue p-text-bold p-mt-3 p-mb-3">
          {{ t('whenToBuy.content.additional') }}
        </p>
        <a
          class="buttonYellow p-mt-2"
          [href]="formUrl('/cta', 'ctaHeader')">
          <app-lock-open-icon></app-lock-open-icon>
          {{ t('buyGapButton') }} >
        </a>
      </div>
    </div>
  </div>
</ng-container>
